import { render, staticRenderFns } from "./v-warning.vue?vue&type=template&id=2a6a7174&scoped=true&"
import script from "./v-warning.vue?vue&type=script&lang=js&"
export * from "./v-warning.vue?vue&type=script&lang=js&"
import style0 from "./v-warning.vue?vue&type=style&index=0&id=2a6a7174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a7174",
  null
  
)

export default component.exports